import { render, staticRenderFns } from "./ExpenditureTypeForm.vue?vue&type=template&id=067a216d&scoped=true&"
import script from "./ExpenditureTypeForm.vue?vue&type=script&lang=js&"
export * from "./ExpenditureTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067a216d",
  null
  
)

export default component.exports